(function() {
  const sliders = document.querySelectorAll('[id^="KISlider-"]');
  
  sliders.forEach(function(slider) {
    if (!slider) return;

    const progressBar = slider.closest('.ki-section').querySelector('.ki-progress');
    const progressLabel = progressBar ? progressBar.querySelector('.slider__label') : null;
    const slides = slider.querySelectorAll('.ki-slider-item');
    
    // Drag functionality
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', function(e) {
      isDown = true;
      slider.classList.add('dragging');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', function() {
      isDown = false;
      slider.classList.remove('dragging');
    });

    slider.addEventListener('mouseup', function() {
      isDown = false;
      slider.classList.remove('dragging');
    });

    slider.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2;
      slider.scrollLeft = scrollLeft - walk;
    });

    // Progress bar update
    if (progressBar && slides.length > 0) {
      slider.addEventListener('scroll', function() {
        const scrollLeft = slider.scrollLeft;
        const scrollWidth = slider.scrollWidth - slider.clientWidth;
        let progress = (scrollLeft / scrollWidth) * 100;
        
        progress = Math.min(100, Math.max(33, progress));
        
        progressBar.style.backgroundSize = progress + '% 100%';
        progressBar.setAttribute('aria-valuenow', Math.round(progress));
        if (progressLabel) {
          progressLabel.textContent = Math.round(progress) + '% completed';
        }
      });
    }
  });
})();

